export const sleep = async (ms) => {
  return new Promise((r) =>
    setTimeout(
      () => r(),
      // console.log(`going to sleep for ${Number(ms)/1000} seconds`)
      ms
    )
  );
};
